import React from "react";
import Link from "../../Link";

import { NewsListLabel } from "../Label";

const List = props => {
  var s = props.settings,
    links = s.links ? s.links : [];

  return (
    <div className="hp__news-list col-xs-12 col-sm-3 no-padding">
      <div className="hp__news-list__header col-xs-12">
        <h4 className="header-title text-center">{s.title}</h4>
        <p className="header-date text-center">{s.date}</p>
      </div>
      <div className="hp__news-list__content col-xs-12">
        <ol className="news-list-ordered">
          {links.map(function(link, i) {
            if (link.description && link.description.length > 0) {
              return (
                <li key={i} className="hp__news-list__element h5">
                  <Link to={link.url}>
                    <p>{link.description}</p>
                    {link.append && (
                      <NewsListLabel> {link.append} </NewsListLabel>
                    )}
                  </Link>
                </li>
              );
            } else {
              return null;
            }
          })}
        </ol>
      </div>

      <div className="hp__news-list__ad col-xs-12 no-margin-padding" />
    </div>
  );
};

export default List;
